import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Form from 'react-bootstrap/Form';
import { Tooltip } from 'react-bootstrap';
import InputTooltip from './InputTooltip';

/**
 * Input components.
 *
 * @param {Object} props configs of input
 */
const Input = props => {
  const {
    value = '',
    label,
    placeholder,
    automcomplete,
    required,
    error,
    tip,
    valid,
    changed,
    minValue
  } = props;
  const { formatMessage } = useIntl();

  let errorMessage = <Form.Text className="empty-field-info">&nbsp;</Form.Text>;

  if (!valid && error) {
    errorMessage = (
      <Form.Text className="error-message-small text-danger">
        <FormattedMessage id={`form.field.${label}.error`} />
      </Form.Text>
    );
  }

  const getMinValue = label => {
    if (label === 'birthDate' || label === 'permZipcode') {
      return minValue;
    }
    return null;
  };

  return (
    <Form.Group controlId={label}>
      <Form.Label className={required ? 'field-required' : null}>
        <FormattedMessage id={`form.field.${label}.label`} />
      </Form.Label>
      {tip && (
        <InputTooltip>
          <Tooltip>
            <FormattedMessage id={`form.field.${label}.tip`} />
          </Tooltip>
        </InputTooltip>
      )}
      <Form.Control
        className={valid ? null : 'is-invalid'}
        type={props.type}
        value={value}
        onChange={changed}
        autoComplete={automcomplete ? 'true' : 'false'}
        required={required}
        placeholder={placeholder ? formatMessage({ id: `form.field.${label}.placeholder` }) : null}
        max={label === 'birthDate' ? new Date().toISOString().slice(0, 10) : null}
        min={getMinValue(label)}
      />
      {errorMessage}
    </Form.Group>
  );
};

export default Input;
